import React from "react";
import LegalLayout from "../components/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" subtitle="Informativa ai sensi degli artt. 13-14 GDPR" lastUpdate="20 maggio 2026">
      <p>
        La presente Informativa sul trattamento dei dati personali è resa ai sensi degli articoli 13 e
        14 del Regolamento UE 2016/679 (di seguito "GDPR") e del D.Lgs. 196/2003 ("Codice Privacy") agli
        utenti che visitano il sito <strong>fantapartenope.it</strong> (di seguito "Sito") e/o si
        iscrivono al torneo di fantacalcio <strong>Fanta Partenope</strong>.
      </p>

      <h2>1. Titolare del Trattamento</h2>
      <p>
        Il Titolare del Trattamento è <strong>ASD Fanta Partenope</strong> (di seguito "Titolare"):
        <br />Sede legale: Via Vittorio Emanuele Terzo, 80013 Casalnuovo di Napoli (NA), Italia
        <br />Partita IVA: 10774701212
        <br />Iscrizione CONI n. 31102317
        <br />Legale rappresentante: Carlo De Caprio (C.F. DCPCRL83A28F839V)
        <br />PEC: <a href="mailto:fantapartenope@pec.it">fantapartenope@pec.it</a>
        <br />WhatsApp/Telefono: <a href="https://wa.me/393778100717" target="_blank" rel="noopener noreferrer">+39 377 8100717</a>
      </p>
      <p>
        Per ogni questione relativa al trattamento dei dati personali, l'interessato può rivolgersi
        direttamente al Titolare ai recapiti sopra indicati.
      </p>

      <h2>2. Categorie di dati personali raccolti</h2>
      <p>Il Titolare tratta esclusivamente le seguenti categorie di dati personali, forniti volontariamente dall'utente o raccolti automaticamente durante la navigazione:</p>
      <ul>
        <li><strong>Dati anagrafici e di contatto</strong>: nome, cognome, indirizzo email, numero di telefono cellulare.</li>
        <li><strong>Dati di pagamento</strong>: il Titolare <strong>non memorizza</strong> dati di carta di credito o coordinate bancarie. Tali dati sono trattati direttamente dal fornitore del servizio di pagamento (Stripe — vedi sezione 5).</li>
        <li><strong>Dati di iscrizione al torneo</strong>: identificativo della transazione, stato del pagamento, importo versato, data di iscrizione.</li>
        <li><strong>Dati del modulo di contatto</strong>: nome, email e contenuto del messaggio inviato.</li>
        <li><strong>Dati relativi ai consensi</strong>: timestamp, indirizzo IP, user-agent al momento della prestazione del consenso (cookie e accettazione termini), conservati per finalità di accountability ex art. 7 GDPR.</li>
        <li><strong>Dati tecnici di navigazione</strong>: indirizzo IP, tipo di browser, sistema operativo, pagine visitate, raccolti in log temporanei a fini di sicurezza e diagnostica.</li>
      </ul>

      <h2>3. Finalità del trattamento e basi giuridiche</h2>
      <p>I dati personali sono trattati per le seguenti finalità, ciascuna basata su una specifica condizione di liceità ai sensi dell'art. 6 GDPR:</p>
      <div className="overflow-x-auto my-4">
        <table className="w-full text-sm border border-white/10 rounded-xl">
          <thead className="bg-fp-surface/60">
            <tr>
              <th className="text-left p-3 border-b border-white/10">Finalità</th>
              <th className="text-left p-3 border-b border-white/10">Base giuridica</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-white/5">
              <td className="p-3">Gestione iscrizione e partecipazione al torneo</td>
              <td className="p-3">Esecuzione del contratto (art. 6.1.b GDPR)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Gestione pagamenti e adempimenti contabili</td>
              <td className="p-3">Obbligo legale (art. 6.1.c GDPR)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Erogazione premi e adempimenti fiscali correlati (ritenuta d'acconto)</td>
              <td className="p-3">Obbligo legale (art. 6.1.c GDPR)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Invio comunicazioni operative e transazionali (conferme, classifiche, comunicazioni torneo)</td>
              <td className="p-3">Esecuzione del contratto (art. 6.1.b GDPR)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Riscontro alle richieste inviate tramite il modulo Contatti</td>
              <td className="p-3">Legittimo interesse a rispondere agli utenti (art. 6.1.f GDPR)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Adempimento obblighi normativi (antifrode, conservazione documentale, contenzioso)</td>
              <td className="p-3">Obbligo legale (art. 6.1.c) / Legittimo interesse (art. 6.1.f)</td>
            </tr>
            <tr>
              <td className="p-3">Registrazione dei consensi (cookie e termini)</td>
              <td className="p-3">Adempimento del principio di accountability (art. 7 GDPR)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <strong>Il Titolare non tratta i dati per finalità di marketing, profilazione, pubblicità o
        invio di newsletter promozionali, né effettua processi decisionali automatizzati ex art. 22 GDPR.</strong>
      </p>

      <h2>4. Modalità del trattamento e sicurezza dei dati</h2>
      <p>
        Il trattamento è effettuato con strumenti informatici e telematici, con misure tecniche e
        organizzative adeguate ai sensi dell'art. 32 GDPR, tra cui:
      </p>
      <ul>
        <li><strong>Cifratura in transito</strong>: tutto il traffico verso il Sito avviene tramite protocollo HTTPS/TLS.</li>
        <li><strong>Hashing delle credenziali</strong>: le password degli amministratori sono memorizzate in formato hash bcrypt.</li>
        <li><strong>Autenticazione</strong>: l'accesso al pannello di gestione richiede autenticazione tramite token JWT con scadenza.</li>
        <li><strong>Separazione dei dati di pagamento</strong>: i dati di carta non transitano e non sono memorizzati sui sistemi del Titolare (gestione delegata a Stripe, certificato PCI-DSS Livello 1).</li>
        <li><strong>Accessi ristretti</strong>: il personale autorizzato accede ai dati solo per quanto strettamente necessario alle proprie mansioni.</li>
        <li><strong>Log di sicurezza</strong>: tracciamento degli accessi al pannello amministrativo.</li>
      </ul>
      <p>
        Nonostante le misure adottate, nessun sistema informatico può garantire una sicurezza
        assoluta. In caso di violazione di dati personali (data breach), il Titolare provvederà alla
        notifica all'Autorità Garante e, ove previsto, agli interessati entro i termini di legge
        (artt. 33 e 34 GDPR).
      </p>

      <h2>5. Destinatari e responsabili esterni del trattamento</h2>
      <p>
        Per erogare il servizio, il Titolare si avvale di soggetti terzi, accuratamente selezionati,
        che agiscono in qualità di Responsabili del Trattamento ai sensi dell'art. 28 GDPR. L'elenco
        completo è disponibile su richiesta scritta. I principali sono:
      </p>
      <ul>
        <li>
          <strong>Stripe Payments Europe Ltd.</strong> — Servizio di gestione pagamenti.
          Sede: 1 Grand Canal Street Lower, Grand Canal Dock, Dublino, Irlanda.
          Informativa: <a href="https://stripe.com/it/privacy" target="_blank" rel="noopener noreferrer">stripe.com/it/privacy</a>.
        </li>
        <li>
          <strong>Google Ireland Limited</strong> — Servizio SMTP per l'invio di email transazionali (Gmail).
          Sede: Gordon House, Barrow Street, Dublino 4, Irlanda. Eventuale trasferimento a Google LLC (USA).
          Informativa: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a>.
        </li>
        <li>
          <strong>Emergent Labs Inc.</strong> — Hosting del Sito, infrastruttura backend e gestione del database (MongoDB).
          Sede: Stati Uniti d'America.
        </li>
        <li>
          <strong>Unsplash Inc.</strong> (Canada) e <strong>Pexels GmbH</strong> (Germania) — CDN per
          la fornitura di alcune immagini predefinite. Possono raccogliere indirizzi IP nell'erogazione
          della risorsa.
        </li>
      </ul>
      <p>
        Inoltre, i dati possono essere comunicati a: consulenti fiscali e legali del Titolare,
        autorità giudiziarie o di vigilanza nell'adempimento di obblighi di legge.
      </p>

      <h2>6. Trasferimento di dati personali fuori dall'Unione Europea</h2>
      <p>
        Alcuni Responsabili (Emergent Labs Inc.) hanno server situati negli Stati Uniti, mentre altri
        (Google) possono trasferire dati a società del gruppo extra-UE. Tali trasferimenti avvengono
        nel rispetto delle garanzie previste dal Capo V GDPR, in particolare mediante:
      </p>
      <ul>
        <li><strong>Clausole Contrattuali Standard (SCC)</strong> approvate dalla Commissione Europea con Decisione 2021/914;</li>
        <li>Misure tecniche supplementari (cifratura) e organizzative;</li>
        <li>Eventuali decisioni di adeguatezza, ove disponibili (es. EU-US Data Privacy Framework per soggetti certificati).</li>
      </ul>

      <h2>7. Periodo di conservazione dei dati</h2>
      <div className="overflow-x-auto my-4">
        <table className="w-full text-sm border border-white/10 rounded-xl">
          <thead className="bg-fp-surface/60">
            <tr>
              <th className="text-left p-3 border-b border-white/10">Categoria di dati</th>
              <th className="text-left p-3 border-b border-white/10">Periodo</th>
              <th className="text-left p-3 border-b border-white/10">Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-white/5">
              <td className="p-3">Dati di iscrizione e pagamento</td>
              <td className="p-3">10 anni</td>
              <td className="p-3">Conservazione documenti contabili (art. 2220 c.c.)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Dati per erogazione premi</td>
              <td className="p-3">10 anni</td>
              <td className="p-3">Adempimenti fiscali (D.P.R. 600/1973)</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Messaggi modulo Contatti</td>
              <td className="p-3">24 mesi</td>
              <td className="p-3">Tempo necessario per riscontro</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3">Registro dei consensi</td>
              <td className="p-3">5 anni dalla revoca/scadenza</td>
              <td className="p-3">Accountability ex art. 7 GDPR</td>
            </tr>
            <tr>
              <td className="p-3">Log tecnici di navigazione</td>
              <td className="p-3">30 giorni</td>
              <td className="p-3">Sicurezza e diagnostica</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>Al termine dei periodi indicati, i dati saranno cancellati o resi anonimi in maniera irreversibile.</p>

      <h2>8. Diritti dell'interessato</h2>
      <p>In qualità di interessato, l'utente ha diritto, ai sensi degli articoli 15-22 GDPR, di:</p>
      <ul>
        <li>Ottenere conferma dell'esistenza di un trattamento di dati e accedervi (<strong>diritto di accesso</strong>, art. 15);</li>
        <li>Ottenere la rettifica di dati inesatti o incompleti (<strong>art. 16</strong>);</li>
        <li>Ottenere la cancellazione dei dati ("<strong>diritto all'oblio</strong>", art. 17), nei limiti consentiti dalla legge;</li>
        <li>Ottenere la limitazione del trattamento (<strong>art. 18</strong>);</li>
        <li>Ricevere i dati in formato strutturato e di uso comune (<strong>diritto alla portabilità</strong>, art. 20);</li>
        <li>Opporsi al trattamento basato sul legittimo interesse (<strong>art. 21</strong>);</li>
        <li>Non essere sottoposto a decisioni automatizzate, inclusa la profilazione (<strong>art. 22</strong>);</li>
        <li><strong>Revocare il consenso</strong> in qualsiasi momento, senza pregiudicare la liceità del trattamento basato sul consenso prestato prima della revoca;</li>
        <li>Proporre reclamo all'<strong>Autorità Garante per la Protezione dei Dati Personali</strong> (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">garanteprivacy.it</a>).</li>
      </ul>
      <p>
        Per esercitare tali diritti, scrivere a <a href="mailto:fantapartenope@pec.it">fantapartenope@pec.it</a> o contattare il Titolare ai recapiti indicati alla sezione 1. Il Titolare risponderà entro 30 giorni, prorogabili di ulteriori 60 giorni in caso di particolare complessità.
      </p>

      <h2>9. Obbligatorietà del conferimento</h2>
      <p>
        Il conferimento dei dati contrassegnati come obbligatori nel modulo di iscrizione è
        necessario per consentire la partecipazione al torneo. Il mancato conferimento comporta
        l'impossibilità di completare l'iscrizione e di usufruire dei servizi.
      </p>

      <h2>10. Minori</h2>
      <p>
        Il servizio è riservato a soggetti di età pari o superiore ai <strong>18 anni</strong>. Il
        Titolare non raccoglie consapevolmente dati di minori. Qualora venisse rilevato un
        trattamento di dati relativi a un minore, i dati saranno tempestivamente cancellati e
        l'iscrizione annullata.
      </p>

      <h2>11. Cookie e tecnologie similari</h2>
      <p>
        Per informazioni dettagliate sull'utilizzo di cookie da parte del Sito, si rinvia alla{" "}
        <a href="/cookie" className="text-fp-cyan hover:underline">Cookie Policy</a>.
      </p>

      <h2>12. Modifiche all'informativa</h2>
      <p>
        Il Titolare si riserva il diritto di modificare la presente Informativa per adeguarla a
        normative successive o a esigenze organizzative. Le modifiche saranno pubblicate su questa
        pagina, con indicazione della <strong>data di ultimo aggiornamento</strong>. In caso di
        modifiche sostanziali, gli iscritti saranno informati per email all'indirizzo fornito in fase
        di iscrizione, almeno 15 giorni prima dell'efficacia delle nuove disposizioni.
      </p>

      <h2>13. Reclami</h2>
      <p>
        L'interessato ha il diritto di proporre reclamo all'<strong>Autorità Garante per la Protezione
        dei Dati Personali</strong>, con sede in Piazza Venezia 11, 00187 Roma, email{" "}
        <a href="mailto:garante@gpdp.it">garante@gpdp.it</a>, PEC{" "}
        <a href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</a>, sito web{" "}
        <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>.
      </p>

      <p className="mt-10 text-xs text-white/40">
        <em>Documento conforme al Regolamento UE 2016/679 (GDPR) — Versione 2026-05-20.</em>
      </p>
    </LegalLayout>
  );
}
